
// ProgressRing.js の【正しい】コード

import React from 'react';

const ProgressRing = ({ radius, stroke, progress, strokeColor = 'text-blue-500', bgColor = 'text-gray-200' }) => {
  const normalizedRadius = radius - stroke / 2; // Adjust for stroke width so it's inside the visible radius
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  const svgSize = radius * 2; // Total size of the SVG canvas

  return (
    <svg
      height={svgSize}
      width={svgSize}
      viewBox={`0 0 ${svgSize} ${svgSize}`}
      className="-rotate-90" // Keep transform on SVG directly
    >
      <circle
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        stroke={bgColor} // Use prop directly as CSS color
      />
      <circle
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{ strokeDashoffset, transition: 'stroke-dashoffset 0.3s ease-out' }}
        strokeLinecap="round"
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        stroke={strokeColor} // Use prop directly as CSS color
      />
    </svg>
  );
};

export default ProgressRing;
